import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Skeleton } from 'antd'
import gql from 'graphql-tag'

const USER_DETAILS = gql`
    query userDetailsByUid(
		$user_uid: String
	) {
		userDetailsByUid(
			user_uid: $user_uid
		)
    }
`

const UserProfile = (props) => {
	const { 
		client, user_uid, ...rest
	} = props

	return (
		<Query 
			query={USER_DETAILS}
			variables={{ user_uid }}
		>
			{({ loading, error, data }) => {
				if (loading) return <Skeleton active/>
				const mUser = _.has(data, 'userDetailsByUid') ? data.userDetailsByUid : {}
				return <span { ...rest }>{mUser.full_name}</span>
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(UserProfile)